export default "__VITE_ASSET__0wIALd_4__"